import { render, staticRenderFns } from "./c-order-success.vue?vue&type=template&id=70c1789b&scoped=true&"
import script from "./c-order-success.vue?vue&type=script&lang=js&"
export * from "./c-order-success.vue?vue&type=script&lang=js&"
import style0 from "./c-order-success.vue?vue&type=style&index=0&id=70c1789b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c1789b",
  null
  
)

export default component.exports